import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {isPlatformBrowser} from '@angular/common';

import {Globals} from '../../../core/services/globals';

import {BsModalRef} from 'ngx-bootstrap/modal';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FormsModule} from '@angular/forms';

import {ReCaptchaV3Service} from 'ng-recaptcha-2';

/* This is a component which we pass in modal*/

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, CollapseModule, FormsModule],
  selector: 'modal-content',
  styles: [],
  templateUrl: './modal-content.component.html',
})
export class ModalContentComponent {
  public title = '';

  public isRegisteredBln = false;

  private searchURlStr = '/includes/classes/REP_SearchProcess.php'; // URL to web api

  public errorStr = '';

  public step2Bln = false;
  model = {
    propertyType: {value: 'Not Specified'},
    area: {value: ''},
    priceRangeMin: {value: '1000000'},
    priceRangeMax: {value: '100000000'},
    bedrooms: {value: 'Any'},
    bathrooms: {value: 'Any'},
    lotSize: {value: 'Any'},
    squareFeet: {value: 'Any'},
    yearBuilt: {value: 'All'},
    firstName: {value: ''},
    lastName: {value: ''},
    phoneNumber: {value: ''},
    emailAddress: {value: ''},
  };
  public uidStr = '';

  public captchaResponseStr: Event | undefined;
  string = '';

  public submitBln = false;

  constructor(
    public bsModalRef: BsModalRef,
    private http: HttpClient,
    public globals: Globals,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const cityStr = globals.districtList;
    if (cityStr != '') {
      this.model.area.value = cityStr;
    }
  }

  public submitForm(id: number) {
    switch (id) {
      case 1:
        // show the second part of the search form
        this.step2Bln = true;
        break;
      case 2:
      // console.log('hello');
      //this.bsModalRef.hide();
      // console.log('closing');
    }
  }

  public executeInitialSubmit(): void {
    this.recaptchaV3Service.execute('registration')
      .subscribe((token) => this.submitInitialData(token));
  }

  public submitInitialData(token: string) {
    // console.log(captchaResponse);
    // set the submit boolean to indicate that work is being done
    this.submitBln = true;
    const paramsObj = this.setupInitialJSONObject(token);
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    this.http.post(this.searchURlStr, params.toString(), httpOptions).subscribe(
      (response) => {
        // re-enable the submit buttons
        this.submitBln = false;
        // console.log(response.json());
        // define properties
        const responseObj = response as any;
        const statusBln = responseObj.statusBln;
        const uidStr = responseObj.uidStr;
        // fork, if there was an error then output the error
        if (!statusBln) {
          this.errorStr = responseObj.errorArr[0];
        }
        if (statusBln) {
          // create the cookie data object
          const d: Date = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
          const expires = `expires=${d.toUTCString()}`;
          // console.log(responseObj);
          document.cookie =
            'containerObj=' +
            responseObj.cookieStr +
            '; ' +
            expires +
            '; path=/';
          // update the user id string for the second part of the form tracking
          this.uidStr = uidStr;
          // show the second part of the search form
          this.step2Bln = true;
          //this.bsModalRef.hide();
          //this.globals.isRegisteredBln="1";
          //if (responseObj.redirectStr!='') window.location.href=responseObj.redirectStr + '&referStr=cm';
        }
      },
      (error) => {
        this.handleError(error); // Centralized error handling
      },
    );
  }

  public submitData() {
    // console.log(captchaResponse);
    // set the submit boolean to indicate that work is being done
    this.submitBln = true;
    // submit the search data
    const paramsObj = this.setupJSONObject();
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    // track the even
    this.http.post(this.searchURlStr, params.toString(), httpOptions).subscribe(
      (response) => {
        // re-enable the submit buttons
        this.submitBln = false;
        // console.log(response.json());
        // define properties
        const responseObj = response as any;
        const statusBln = responseObj.statusBln;
        // fork, if there was an error then output the error
        if (!statusBln) {
          this.errorStr = responseObj.errorArr[0];
          // reset the recaptcha
          //let myWindow: any = window;
          // myWindow.grecaptcha.reset();
        }
        if (statusBln) {
          // create the cookie data object
          const d: Date = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
          const expires = `expires=${d.toUTCString()}`;
          // console.log(responseObj);
          document.cookie =
            'containerObj=' +
            responseObj.cookieStr +
            '; ' +
            expires +
            '; path=/';
          this.bsModalRef.hide();
          this.globals.isRegisteredBln = '1';
          this.globals.userIDStr = responseObj.userIDStr;
          // console.log('Registering User Complete');
          // console.log(this.globals);
          //if (responseObj.redirectStr!='') window.location.href=responseObj.redirectStr + '&referStr=cm';
        }
      },
      (error) => {
        this.handleError(error); // Centralized error handling
      },
    );
  }

  public submitSkipData() {
    // console.log(captchaResponse);
    // submit the search data
    const paramsObj = this.setupSkipJSONObject();
    const params = new HttpParams({
      fromObject: paramsObj,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    // track the even
    this.http.post(this.searchURlStr, params.toString(), httpOptions).subscribe(
      (response) => {
        // console.log(response.json());
        // define properties
        const responseObj = response as any;
        const statusBln = responseObj.statusBln;
        // fork, if there was an error then output the error
        if (!statusBln) {
          this.errorStr = responseObj.errorArr[0];
        }
        if (statusBln) {
          // create the cookie data object
          const d: Date = new Date();
          d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
          const expires = `expires=${d.toUTCString()}`;
          // console.log(responseObj);
          document.cookie =
            'containerObj=' +
            responseObj.cookieStr +
            '; ' +
            expires +
            '; path=/';
          this.globals.isRegisteredBln = '1';
          this.bsModalRef.hide();
          //if (responseObj.redirectStr!='') window.location.href=responseObj.redirectStr + '&referStr=cm';
        }
      },
      (error) => {
        this.handleError(error); // Centralized error handling
      },
    );
  }

  public setupInitialJSONObject(token: string) {
    // define properties
    const modelObj = this.model;
    const siteIDStr = this.globals.siteIDStr;
    const firstNameStr = modelObj.firstName.value;
    const lastNameStr = modelObj.lastName.value;
    const emailAddressStr = modelObj.emailAddress.value;
    const phoneNumberStr = modelObj.phoneNumber.value;
    const ipAddrStr = this.globals.ipAddrStr;
    //set the email address in the global property
    this.globals.emailStr = emailAddressStr;
    // create the JSON Post Object container
    const JSONObj = {
      siteIDStr: siteIDStr,
      firstNameStr: firstNameStr,
      lastNameStr: lastNameStr,
      emailStr: emailAddressStr,
      phoneStr: phoneNumberStr,
      ipAddrStr: ipAddrStr,
      initBln: true,
      'g-recaptcha-response-v3': token
    };
    return JSONObj;
  }

  public setupSkipJSONObject() {
    // define properties
    const modelObj = this.model;
    const siteIDStr = this.globals.siteIDStr;
    const firstNameStr = modelObj.firstName.value;
    const lastNameStr = modelObj.lastName.value;
    const emailAddressStr = modelObj.emailAddress.value;
    const phoneNumberStr = modelObj.phoneNumber.value;
    const ipAddrStr = this.globals.ipAddrStr;
    const uidStr = this.uidStr;
    // create the JSON Post Object container
    const JSONObj = {
      siteIDStr: siteIDStr,
      firstNameStr: firstNameStr,
      lastNameStr: lastNameStr,
      emailStr: emailAddressStr,
      phoneStr: phoneNumberStr,
      ipAddrStr: ipAddrStr,
      uidStr: uidStr,
      registerFullBln: true,
    };
    return JSONObj;
  }

  public setupJSONObject() {
    // define properties
    const modelObj = this.model;
    const siteIDStr = this.globals.siteIDStr;
    const propertyTypeStr = modelObj.propertyType.value;
    const areaStr = modelObj.area.value;
    const priceRangeMinStr = modelObj.priceRangeMin.value;
    const priceRangeMaxStr = modelObj.priceRangeMax.value;
    const bedroomsStr = modelObj.bedrooms.value;
    const bathroomsStr = modelObj.bathrooms.value;
    const lotSizeStr = modelObj.lotSize.value;
    const squareFeetStr = modelObj.squareFeet.value;
    const yearBuiltStr = modelObj.yearBuilt.value;
    const firstNameStr = modelObj.firstName.value;
    const lastNameStr = modelObj.lastName.value;
    const emailAddressStr = modelObj.emailAddress.value;
    const phoneNumberStr = modelObj.phoneNumber.value;
    const ipAddrStr = this.globals.ipAddrStr;
    const uidStr = this.uidStr;
    // create the JSON Post Object container
    const JSONObj = {
      siteIDStr: siteIDStr,
      Property_Type: propertyTypeStr,
      searchArea: areaStr,
      searchMin: priceRangeMinStr,
      searchMax: priceRangeMaxStr,
      searchBedrooms: bedroomsStr,
      searchBathrooms: bathroomsStr,
      searchLotSize: lotSizeStr,
      searchSquareFeet: squareFeetStr,
      searchYearBuilt: yearBuiltStr,
      firstNameStr: firstNameStr,
      lastNameStr: lastNameStr,
      emailStr: emailAddressStr,
      phoneStr: phoneNumberStr,
      ipAddrStr: ipAddrStr,
      uidStr: uidStr,
      registerFullBln: true,
      redirectURLStr: '/listings/dist/',
    };
    return JSONObj;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  // Example for window/document usage:
  redirectToUrl(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    }
  }

  setCookie(name: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie = `${name}=${value}`;
    }
  }
}
